import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overwatch',
  templateUrl: './overwatch.component.html',
  styleUrls: ['./overwatch.component.css']
})
export class OverwatchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
